import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../assets/westcounty-mark.png';
import { content } from '../config/site.js';
import LanguagePicker from './LanguagePicker.jsx';

export default function Header({ lang, setLang }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const t = content[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);


  return (
    <header className={scrolled ? 'site-header is-compact' : 'site-header'}>
      <a className="brand" href="/" aria-label="GTA:WestCounty Home">
        <img src={logo} alt="GTA:WestCounty" />
        <span>GTA:WestCounty</span>
      </a>

      <nav className={menuOpen ? 'nav is-open' : 'nav'}>
        {t.nav.map((item) => (
          <a key={item.target} href={`#${item.target}`} onClick={() => setMenuOpen(false)}>
            {item.label}
          </a>
        ))}
      </nav>

      <div className="header-actions">
        <LanguagePicker lang={lang} setLang={setLang} label={t.common.chooseLanguage} />

        <a className="login-link" href="/account/login">{t.common.login}</a>
        <button className="menu-toggle" type="button" onClick={() => setMenuOpen((value) => !value)} aria-label="Menu">
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
}
